import Mustache from 'mustache';
import { csrfToken, isSp, imgPreload } from '@/js/_common';
import magazineCardHtml from '@/js/html_templates/magazine-card.html';

const FETCH_URL = '/api/magazine/list';

const loadData = async (page, cond) => {
    const params = new URLSearchParams();
    params.append('page', page);
    for (const [key, value] of Object.entries(cond)) {
        if (value) {
            params.append(key, value);
        }
    }

    return await fetch(`${FETCH_URL}?${params.toString()}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrfToken
        },
    }).then(response => response.json());
}

const loadMore = async () => {
    const listSection = document.querySelector('.c-lists-magazine');
    if (!listSection) return;

    if (listSection.dataset.lastPage == listSection.dataset.page) {
        const loading = document.querySelector('.c-lists-magazine__loading');
        if (loading) loading.remove();
        return;
    }

    const params = JSON.parse(listSection.dataset.params || '{}');
    const page = Number(listSection.dataset.page) + 1;
    const resp = await loadData(page, params);
    listSection.dataset.page = resp.magazine_list.current_page;

    let imgList = [];
    resp.magazine_list.data.forEach(magazine => {
        const html = Mustache.render(magazineCardHtml, magazine);
        listSection.querySelector('.c-lists-magazine__items').insertAdjacentHTML('beforeend', html);
        imgList.push(magazine.thumbnail_url);
    });

    await imgPreload(imgList);
    listSection.querySelectorAll('.c-cards-magazine.is-loading').forEach(card => {
        card.classList.remove('is-loading');
    });

    const searchParams = new URLSearchParams(location.search.replace(/^\?/, ''));
    let queryParamsObject = Object.fromEntries(searchParams.entries());
    queryParamsObject = { ...queryParamsObject, page };
    history.replaceState('', '', `${location.pathname}?${new URLSearchParams(queryParamsObject).toString()}`);
}

const reloadList = async (cond) => {
    const listSection = document.querySelector('.c-lists-magazine');
    if (!listSection) return;

    listSection.dataset.params = JSON.stringify(cond);
    listSection.dataset.page = 0;
    listSection.dataset.lastPage = 1;

    // Clear existing items
    const items = listSection.querySelector('.c-lists-magazine__items');
    items.innerHTML = '';

    // Remove old loading, add new
    const oldLoading = listSection.querySelector('.c-lists-magazine__loading');
    if (oldLoading) oldLoading.remove();
    const loading = document.createElement('div');
    loading.className = 'c-lists-magazine__loading';
    listSection.appendChild(loading);

    // Fetch first page
    const resp = await loadData(1, cond);
    listSection.dataset.page = resp.magazine_list.current_page;
    listSection.dataset.lastPage = resp.magazine_list.last_page;

    // Update count
    const countEl = listSection.querySelector('.c-lists-magazine__count');
    if (countEl) {
        countEl.dataset.count = resp.magazine_list.total;
        countEl.querySelector('p').innerHTML = `全<span>${resp.magazine_list.total}</span>件`;
    }

    if (resp.magazine_list.data.length === 0) {
        items.innerHTML = '<div class="c-lists-magazine-none"><p class="c-lists-magazine-none__text">条件に合うマガジンが見つかりませんでした。</p></div>';
        loading.remove();
        return;
    }

    let imgList = [];
    resp.magazine_list.data.forEach(magazine => {
        const html = Mustache.render(magazineCardHtml, magazine);
        items.insertAdjacentHTML('beforeend', html);
        imgList.push(magazine.thumbnail_url);
    });

    await imgPreload(imgList);
    listSection.querySelectorAll('.c-cards-magazine.is-loading').forEach(card => {
        card.classList.remove('is-loading');
    });

    if (resp.magazine_list.last_page <= 1) {
        loading.remove();
    } else {
        observeLoading();
    }

    // Update URL
    const queryParams = new URLSearchParams();
    for (const [key, value] of Object.entries(cond)) {
        if (value) queryParams.set(key, value);
    }
    const qs = queryParams.toString();
    history.replaceState('', '', `${location.pathname}${qs ? '?' + qs : ''}`);
}

let scrollIo = null;

const observeLoading = () => {
    if (scrollIo) scrollIo.disconnect();
    const loadingEl = document.querySelector('.c-lists-magazine__loading');
    if (!loadingEl) return;
    scrollIo = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
            loadMore();
        }
    });
    scrollIo.observe(loadingEl);
}

const main = () => {
    if (document.querySelector('#page-magazine-index') == null) return;
    observeLoading();
}

export default main;
